import React from 'react';

export const PainelLogarContexto = React.createContext(null);